import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    seferList: [],
    selectedSeferList: [],
    selectedSefer: {},
  }),

  mutations: {
    setSeferList(state, seferList) {
      Vue.set(state, "seferList", seferList);
    },
    setSelectedSeferList(state, selectedSeferList) {
      Vue.set(state, "selectedSeferList", selectedSeferList);
    },
    setSelectedSefer(state, selectedSefer) {
      Vue.set(state, "selectedSefer", selectedSefer);
    },
    setDefaultSeferModule(state, selectedSefer) {
      Vue.set(state, "seferList", []);
      Vue.set(state, "selectedSeferList", []);
      Vue.set(state, "selectedSefer", {});
    },
  },

  actions: {
    loadSeferList: (context, request) => {
      return (
        axios
          //TODO
          .post(context.getters.getTmsServiceUrl + "/train/get-list", request)
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadSeferListBetweenDates: (context, request) => {
      return (
        axios
          //TODO
          .post(context.getters.getTmsServiceUrl + "/train/get-list-between-dates", request)
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    saveSefer: (context, train) => {
      return (
        axios
          //TODO
          .post(context.getters.getMcServiceUrl + "/train/entity", train)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadSefer: (context, train) => {
      return (
        axios
          //TODO
          .get(context.getters.getMcServiceUrl + "/train/entity/" + train.id)
          .then((response) => {
            context.commit("setSelectedSefer", response.data);
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    publishSefer: (context, train) => {
      return axios.get(context.getters.getMcServiceUrl + "/train/publish/" + train.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    deleteSefer: (context, train) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train/entity/" + train.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          train.intents = intents;
          train.intentId = response.data.id;
          return train;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftSefer: (context, train) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train/draft/" + train.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    trainUpdateOrer: (context, train) => {
      return axios
        .put(context.getters.getMcServiceUrl + "/trains/update-orer", train)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    updateTrainPricing: (context, train) => {
      return (
        axios
          //TODO
          .put(context.getters.getTmsServiceUrl + "/train/update-train-pricing", train)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    updateTrainCars: (context, train) => {
      return (
        axios
          //TODO
          .put(context.getters.getMcServiceUrl + "/trains/update-train-cars", train)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    openToSale: (context, trainIds) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/trains/open-trains-for-sale", trainIds)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    closeToSale: (context, trainIds) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/trains/close-trains-for-sale", trainIds)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    reverseTrainDirection: (context, trainIds) => {
      return (
        axios
          //
          .post(context.getters.getMcServiceUrl + "/trains/reverse-train-directions", trainIds)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    deleteTrains: (context, trainIds) => {
      return (
        axios
          //TODO
          .delete(context.getters.getMcServiceUrl + "/trains/batch-delete-trains", { data: trainIds })
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },

    loadTrainHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/trains/history/" + request, {}).then((response) => {
        return response.data;
      });
    },
    checkSeferSale: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/train/sale-check", request)
        .then((response) => response)
        .catch((err) => err.response);
    },
  },

  getters: {
    getSeferList: (state) => {
      return state.seferList;
    },
    getSelectedSeferList: (state) => {
      return state.selectedSeferList;
    },
    getSelectedSefer: (state) => {
      return state.selectedSefer;
    },
  },
};
